import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AudioLines, Camera, Loader2, Type, AlertTriangle, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/finance";

export const KIND_ICON = { audio: AudioLines, photo: Camera, text: Type };
export const STATUS = {
  pendiente: { label: "Subida · procesando", busy: true },
  transcrita: { label: "Transcrita · extrayendo", busy: true },
  extraida: { label: "Lista para confirmar" },
  aplicada: { label: "Aplicada" },
  descartada: { label: "Descartada" },
  error: { label: "Error" },
};

export const CaptureRow = ({ c }) => {
  const Icon = KIND_ICON[c.kind];
  const st = STATUS[c.status];
  return (
    <Link to={`/conecta/capturas/${c.id}`} data-testid="capture-row" className="c-card p-3.5 flex items-start gap-3 active:scale-[0.99] transition-transform">
      <Icon className="w-5 h-5 c-accent mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold truncate">{c.summary || c.transcription || c.text_input || "Procesando…"}</p>
        <p className="text-[11px] c-muted">{c.user_name} · {fmtDateTime(c.created_at)}</p>
        {c.in_review && c.review_reasons?.[0] && <p className="text-xs text-amber-700 dark:text-amber-400 mt-1 line-clamp-2">{c.review_reasons[0]}</p>}
      </div>
      <span data-testid="capture-row-status" className={`text-[11px] font-semibold whitespace-nowrap flex items-center gap-1 ${c.status === "error" ? "text-red-500" : c.status === "extraida" ? "c-accent" : "c-muted"}`}>
        {st.busy && <Loader2 className="w-3 h-3 animate-spin" />}
        {c.status === "error" && <AlertTriangle className="w-3 h-3" />}
        {c.status === "aplicada" && <CheckCircle2 className="w-3 h-3" />}
        {st.label}
      </span>
    </Link>
  );
};

export const useCaptures = (params, refreshKey) => {
  const [items, setItems] = useState(null);
  const query = JSON.stringify(params);
  useEffect(() => {
    let alive = true;
    let t;
    const load = () => api.get("/captures", { params: JSON.parse(query) }).then((r) => {
      if (!alive) return;
      setItems(r.data);
      if (r.data.some((c) => STATUS[c.status].busy)) t = setTimeout(load, 3000);
    }).catch(() => {});
    load();
    const h = () => { clearTimeout(t); setTimeout(load, 800); };
    window.addEventListener("capture:uploaded", h);
    return () => { alive = false; clearTimeout(t); window.removeEventListener("capture:uploaded", h); };
  }, [query, refreshKey]);
  return items;
};
